import request from "../axios-instance";
import type {
  DsdCompareHistoryResponse,
  DsdDsdCompareResponse,
  DsdFileListResponse,
  UploadDsdResponse,
} from "./types";

// ── 백엔드 원본 값 → 프론트 기존 포맷 변환 ──

const PERIOD_LABELS: Record<string, string> = {
  Q1: "1분기",
  Q2: "반기",
  Q3: "3분기",
  Q4: "사업",
};

const REPORT_TYPE_LABELS: Record<string, string> = {
  consolidated: "연결",
  separate: "별도",
};

const formatPeriod = (v: string | null): string =>
  PERIOD_LABELS[v ?? ""] ?? v ?? "";

const formatReportType = (v: string | null): string =>
  REPORT_TYPE_LABELS[v ?? ""] ?? v ?? "";

const formatYear = (v: string | null): string => (v ? `${v}년도` : "");

export const uploadDsd = async (file: File): Promise<UploadDsdResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await request.post("/v1/dsd-dsd-compare/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = response.data as UploadDsdResponse;
  return {
    ...data,
    year: formatYear(data.year),
    period: formatPeriod(data.period),
    reportType: formatReportType(data.reportType),
  };
};

export const logDsdDsdCompareDownload = async (): Promise<void> => {
  await request.post("/v1/dsd-dsd-compare/logs/download");
};

export const compareDsdDsd = async (
  srcFileId: string,
  trgFileId: string,
): Promise<DsdDsdCompareResponse> => {
  const response = await request.post(
    "/v1/dsd-dsd-compare/compare",
    JSON.stringify({
      request: {
        srcFileId: srcFileId,
        trgFileId: trgFileId,
      },
    }),
  );
  return response.data;
};

export const getDsdCompareHistory = async (params: {
  cursor?: string | null;
  limit?: number;
}): Promise<DsdCompareHistoryResponse> => {
  const response = await request.get("/v1/dsd-dsd-compare/history", {
    params: {
      ...(params.cursor && { cursor: params.cursor }),
      ...(params.limit && { limit: params.limit }),
    },
  });
  const data = response.data as DsdCompareHistoryResponse;
  return {
    ...data,
    items: data.items.map((item) => ({
      ...item,
      year: formatYear(item.year),
      period: formatPeriod(item.period),
      reportType: formatReportType(item.reportType),
    })),
  };
};

export const getDsdFiles = async (): Promise<DsdFileListResponse> => {
  const response = await request.get("/v1/dsd-dsd-compare/files");
  const data = response.data as DsdFileListResponse;
  return {
    ...data,
    files: data.files.map((file) => ({
      ...file,
      year: formatYear(file.year),
      period: formatPeriod(file.period),
      reportType: formatReportType(file.reportType),
    })),
  };
};
